import { Component } from '@angular/core';
import { LayoutSidebarService } from '../../../shared/services/layout-sidebar.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-backdrop',
  imports: [
    CommonModule,
  ],
  templateUrl: './backdrop.component.html',
})

export class BackdropComponent {
  readonly isMobileOpen;

  constructor(private sidebarService: LayoutSidebarService) {
    this.isMobileOpen = this.sidebarService.isMobileOpen();
  }

  closeSidebar() {
    this.sidebarService.setMobileOpen(false);
  }
}
